module.exports = Studio.libraries['bluebird'];


/*****************
 ** WEBPACK FOOTER
 ** external "Studio.libraries['bluebird']"
 ** module id = 6
 ** module chunks = 0
 **/